import * as React from "react";
import { connect } from "react-redux";
import withStyles from "@material-ui/core/styles/withStyles";
import Link from "react-router-dom/es/Link";
import DoubleArrowRight from "../../components/Icons/DoubleArrowRight";
import PropTypes from "prop-types";
import { appAction } from "../../actions/app.action";
import { clientAction } from "../../actions/client.action";
import SectionHeader from "../../components/UI/SectionHeader";
import SectionCaption from "../../components/UI/SectionCaption";
import { ssiConfig } from "../../utilities/constant";

const styles = (theme) => ({
  contentWrapper: {
    width: "100%",
    display: `flex`,
    flexDirection: "column",
    paddingBottom: theme.wbiComponent.welcomeComponent.height + 20,
  },
  contentCaption: {
    marginBottom: 10,
    fontSize: 21,
    lineHeight: 1.2,
  },
  videoWrapper: {
    width: "100%",
    position: "relative",
    paddingBottom: "45%",
    height: "0",
    marginTop: 40,
    [theme.breakpoints.down("md")]: {
      marginTop: "3%",
    },
  },
  video: {
    width: "100%",
    height: "100%",
    position: "absolute",
    top: "0",
    bottom: "0",
    left: "0",
    right: "0",
  },
  controller: {
    width: theme.wbiComponent.ctaController.totalWidth,
    [theme.breakpoints.down("md")]: {
      width: "45px",
    },
    height: "100%",
    position: "fixed",
    right: 0,
    top: 0,
    zIndex: 0,
    background: `linear-gradient(-189deg, ${theme.palette.secondary.main} 0%, ${theme.palette.secondary.dark} 94%)`,
    boxShadow: "inset 0 0 17px rgba(0,0,0,0.6)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    "& button": {
      height: 360,
      width: "100%",
      background: "transparent",
      cursor: "pointer",
      border: "none",
    },
    "@media print": {
      display: "none",
    },
  },
  welcome: {},
  welcomeCaption: {
    color: theme.palette.primary.main,
  },
  saveButtonNavItem: {
    width: theme.wbiComponent.staticNavigation.totalWidth,
    left: 0,
    textTransform: "uppercase",
    color: theme.palette.grey[50],
    fontSize: 14,
    [theme.breakpoints.down("md")]: {
      fontSize: 12,
    },
    "& svg": {
      [theme.breakpoints.down("md")]: {
        width: 18,
      },
    },
  },
});

class Welcome extends React.Component {
  state = {};

  componentDidMount() {
    this.props.dispatch(appAction.toggleMainNav(false, false));
    this.props.dispatch(appAction.setAddClientNav(true));
    window.scrollTo(0, 0);

    if (this.props.currentHousehold == null) {
      this.props.dispatch(
        clientAction.updateAdvisorConfig({
          ...(this.props.user.user.advisorConfig
            ? this.props.user.user.advisorConfig
            : this.props.user.advisorConfig),
          ...ssiConfig,
        })
      );
    }
    this.props.dispatch(appAction.updateProgressStep(0));
  }

  render() {
    const { classes, householdId, app } = this.props;

    return (
      <div className={classes.contentWrapper}>
        <div className={classes.content}>
          <SectionHeader text={"Welcome"} />
          <SectionCaption className={classes.welcome}>
            The foundation of Cy’s process is built to help investors
            by identifying their loss and return profile.
            <span className={classes.welcomeCaption}>
              <b>
                We believe getting the loss tolerance right is the single most
                important factor in helping clients achieve their investment
                goals.{" "}
              </b>
            </span>
            It starts here.
          </SectionCaption>

          <div className={classes.videoWrapper}>
            <iframe
              className={classes.video}
              title="WBICy Welcome Video"
              src={app.educationVideoPath}
              width="640"
              height="360"
              frameBorder="0"
              allowFullScreen
            />
          </div>

          <div className={classes.controller}>
            <Link
              to={
                householdId ? `/Portal/household/${householdId}/client` : `/Portal/new`
              }
            >
              <button className={classes.saveButtonNavItem}>
                Save
                <DoubleArrowRight />
              </button>
            </Link>
          </div>
        </div>
      </div>
    );
  }
}

Welcome.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
  user: PropTypes.object.isRequired,
  currentHousehold: PropTypes.object,
  householdId: PropTypes.string,
};

const mapStateToProps = (state, ownProps) => {
  return {
    app: state.app,
    user: state.user,
    currentHousehold: state.household.currentHousehold,
    householdId: ownProps.match.params.householdId,
  };
};
export default withStyles(styles, { withTheme: true })(
  connect(mapStateToProps)(Welcome)
);



// WEBPACK FOOTER //
// ./src/containers/Welcome/index.jsx